// extracted by mini-css-extract-plugin
module.exports = {"icon":"_37eUMxk_sUjm","red":"_1-kgPMgai3ZQ","gray":"_2v9cpl_w_dL7","note":"_3OzU8qVZIKWx","title":"_2Y7TBGFZHmJ9","text":"HAR8B9VBxNr8"};